import React, { useState } from "react";
import Box from "@mui/material/Box";
import I18N from "oc-modules/oc-I18N";
import Container from "@mui/material/Container";
import { useTheme } from "@mui/material/styles";
import { Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useHistory } from 'react-router-dom';
import Locations from './Locations';
import SliderMain from "../organisms/SliderMain";
import Divider from "@mui/material/Divider";
import Grid from "@material-ui/core/Grid";
import { SearchInput } from "../organisms/Search";
import DefaultImageSvg from '../styles/images/image.svg';
import SVG from "react-inlinesvg";

function ExhibitionCard(props) {
  const theme = useTheme();
  const history = useHistory();
  const [hover, setHover] = useState(false);

  const onHover = () => {
    setHover(true);
  };

  const onLeave = () => {
    setHover(false);
  };

  const handleExhibitionClick = (event, exhibition) => {
    history.push(`/${exhibition.id}/booths`);
    APP.arrangement.setExhibition(exhibition.id);
  }

  return (
    <Grid item
          xs={12} sm={6} md={4} lg={3}
          data-locations={
            props.item.Locations?.map(l => l.Name).join(', ')
          }
          data-type="exhibitionListItem">
      <Box
        key={props.item.Displayed_Name}
        sx={{
          borderRadius: '10px',
          border: '1px solid #E2E2E2',
          padding: "1em",
          width: '100%',
          height: '210px',
          textAlign: 'center',
          "&:hover": {
            background: 'linear-gradient(90deg, #E94452 0%, #EC622F 100%)',
            '.MuiTypography-root': {
              color: '#fff',
            },
            cursor: 'pointer',
          },
        }}
        onMouseEnter={onHover}
        onMouseLeave={onLeave}
        onClick={(event) => handleExhibitionClick(event, props.item)}
      >
        {!hover &&
        <Box sx={{
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '100%',
        }}>
          {props.item.ExhibitionLogo && (
            <img
              src={`${props.item.ExhibitionLogo}`}
              srcSet={`${props.item.ExhibitionLogo}`}
              alt={props.item.Displayed_Name}
              width={'auto'}
              height={60}
              loading="lazy"
            />
          )}
          {!props.item.ExhibitionLogo && (
            <Box
              sx={{
                width: '100%',
                height: '60px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#E2E2E2',
              }}
            >
              <SVG src={DefaultImageSvg} sx={{fill: '#fff'}} />
            </Box>
          )}
          <Typography id={'ex-title'} variant="subtitle1" sx={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            width: '70%',
            overflow: 'hidden',
            marginBottom: 3,
            fontWeight: 700,
          }} gutterBottom component="div">
            {props.item.Displayed_Name}
          </Typography>
          <Typography id={'ex-subtitle'} variant="caption" gutterBottom component="div">
            {props.item.TimePeriod}
          </Typography>
        </Box>
        }
        {hover &&
        <Box sx={{
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '100%',
        }}>
          <Typography id={'ex-title'} variant="subtitle1" sx={{
            marginTop: 'auto',
            marginBottom: 3,
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            width: '70%',
            fontWeight: 700,
          }} gutterBottom component="div">
            {props.item.Displayed_Name}
          </Typography>
          <Typography id={'ex-subtitle'} variant="caption" sx={{marginBottom: '10px'}} component="div">
            {props.item.TimePeriod}
          </Typography>
          <Divider variant="middle" sx={{ borderColor: '#fff', width: '30%', marginBottom: '18px', borderWidth: '2px !important', }} />
          <Typography variant="caption" gutterBottom component="div">
            {props.item.Locations[0].Displayed_Name}
          </Typography>
          <IconButton
            sx={{
              p: '3px',
              borderRadius: '50%',
              backgroundColor: '#C91113',
              alignSelf: 'flex-end',
              marginTop: 'auto',
              marginLeft: 'auto',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.3)'
              }
            }}
            color="white"
            aria-label={`info about ${props.item.title}`}
          >
            <ArrowForwardIcon />
          </IconButton>
        </Box>
        }
      </Box>
    </Grid>
  )
}

export function Exhibitions() {
  const theme = useTheme();
  const sellerImage = APP.metadata.Basis[0].Logo;
  const exhibitions = APP.richMetadata.getAllExhibitions();

  return (
    <Box sx={{ flexGrow: 0 }}>
      <SliderMain />
      <Container sx={{ paddingBottom: '52px', }}>

        <Box sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          mb: '16px',
          ['@media (max-height: 670px)']: {
            mb: '6px',
          }
        }}>
          <Typography id={'venues-head'} variant="h6" component="div" sx={{ fontWeight: 'bold', marginRight: 'auto', whiteSpace: 'nowrap' }}>
            {I18N("Venues")}
          </Typography>

          <SearchInput />
        </Box>

        <Box id={'locations'} sx={{
          mb: '45px',
          ['@media (max-height: 670px)']: {
            mb: '10px',
          }
        }}>
          <Locations />
        </Box>

        <Typography id={'exhibitions-head'} variant="h6" component="div" sx={{
          fontWeight: 'bold',
          mb: '16px',
          ['@media (max-height: 670px)']: {
            mb: '6px',
          }
        }}>
          {I18N("Exhibitions")}
        </Typography>

        <Typography id={'search-head'} variant="h6" component="div" sx={{ fontWeight: 'bold', display: 'none', mb: '16px' }}>
          {I18N("Search results")}
        </Typography>

        <Grid container sx={{ width: '100%', marginTop: 0 }} spacing={2}>
          {exhibitions.map((item, index) => (
            <ExhibitionCard key={item.Displayed_Name} item={item} />
          ))}
        </Grid>
        <Box id={'no-results'} sx={{display: 'none', width: '100%', margin: '60px 0'}}>
          <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <Typography variant="h6" gutterBottom component="div" sx={{ fontWeight: 'bold', color: '#939599' }}>
              {I18N("No Search Results")}
            </Typography>
          </Box>
        </Box>
        <div style={{height: '33px'}} />
      </Container>
    </Box>
  );
}
